export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = " REMOVE_FROM_CART";
export const ADJUST_QUT = "ADJUST_QUT";
export const LOAD_CURRENT_ITEM = "LOAD_CURRENT_ITEM";
export const INCREMENT = "INCREMENT";
export const DECREMENT = "DECREMENT";
